<!-- @format -->

<ng-container *transloco="let t">
  @if (enrolment) {
    <sis-study-notification-box
      [type]="getNotificationType()"
      [primaryButtonText]="primaryButtonText"
      (primaryClickAction)="primaryClickAction.emit()"
      [secondaryButtonText]="secondaryButtonText"
      (secondaryClickAction)="secondaryClickAction.emit()">
      @if (enrolment.state === "PROCESSING" && !["NOT_PROCESSED", "NOT_VALID"].includes(enrolment.processingState)) {
        {{ t(enrolment.processingState | enrolmentProcessingStateMessageKey) }}
      }
      @if (processedStates.includes(enrolment.state)) {
        {{ t("COURSE_UNIT_REALISATION.ENROLMENT_STATE_FOR_VIEW." + enrolment.state) }}
      }
    </sis-study-notification-box>
  }
</ng-container>
